/**
 * The settings module's routes, owned by the feature. D5.
 *
 * D5 says a feature exports its own routes and `app/router.tsx` composes them. **Both halves are
 * true since T71 closed F-069**: this array is the feature's, and `src/app/router.tsx` spreads it.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const SettingsPage = lazy(() => import('./SettingsPage'));

export const settingsRoutes: RouteObject[] = [{ path: 'settings', element: <SettingsPage /> }];
